import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';

/** Reference data the coach screens filter by: periods, levels, grades and departments. */
@Injectable({providedIn: 'root'})
export class CoachCatalogService {

  private apiPrefix = '/coach/catalog';

  constructor(
    private api: ApiService,
  ) {
  }

  getPeriods(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/periods`);
  }

  /** Levels come with their per-exam score ranges, which the level badge reads. */
  getLevels(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/levels`);
  }

  /** Grade labels differ per period, so the listed period is named explicitly. */
  getGrades(periodId?: number | null): Observable<any> {
    return this.api.get(`${this.apiPrefix}/grades`, periodId ? `?periodId=${periodId}` : '');
  }

  getDepartments(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/departments`);
  }

  getExams(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/exams`);
  }

  /** Every lesson; the planner draws a column per lesson exactly as the student's own does. */
  getLessons(queryString = '?isAll=1'): Observable<any> {
    return this.api.get(`${this.apiPrefix}/lessons`, queryString);
  }

  getExamLessons(examId: number): Observable<any> {
    return this.api.get(`${this.apiPrefix}/exams/${examId}/lessons`);
  }

  getExamLessonTopics(examId: number, lessonId: number): Observable<any> {
    return this.api.get(`${this.apiPrefix}/exams/${examId}/lessons/${lessonId}/topics`);
  }
}
